// セーフエリア（iPhone のステータスバー・ノッチ／Dynamic Island・ホームインジケーター）。
// CSS は --safe-t / --safe-b / --safe-l / --safe-r だけを見る（既定は env(safe-area-inset-*)）。
// 確認用：URL に ?safe=59,34（上,下[,左,右]）を付けると擬似的に余白を入れて撮れる（localStorage に残る。?safe=off で解除）。
// iOS Safari（タブ表示）でページがステータスバーの裏まで伸びているのに env() が 0 を返す場合に備え、上だけ機種の目安で補う。
const KEY = 'hk.safe';

function readParam(): string | null {
  const q = new URLSearchParams(location.search).get('safe');
  if (q != null) return q;
  const h = location.hash.indexOf('?');
  return h >= 0 ? new URLSearchParams(location.hash.slice(h + 1)).get('safe') : null;
}

function override(): number[] | null {
  let v = readParam();
  try {
    if (v != null) {
      if (v === 'off' || v === '0' || v === '') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, v);
    }
    v = localStorage.getItem(KEY);
  } catch {
    /* 無視 */
  }
  if (!v) return null;
  const n = v.split(',').map((x) => Math.max(0, Number(x) || 0));
  return [n[0] ?? 0, n[1] ?? 0, n[2] ?? 0, n[3] ?? 0];
}

/** env(safe-area-inset-top) の実際の値（px） */
function envTop(): number {
  const p = document.createElement('div');
  p.style.cssText = 'position:fixed;top:0;left:0;width:0;height:env(safe-area-inset-top,0px);visibility:hidden;pointer-events:none';
  document.body.appendChild(p);
  const h = p.getBoundingClientRect().height;
  p.remove();
  return h;
}

function iosGuessTop(): number {
  const ua = navigator.userAgent;
  const ios = /iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1 && /iPad/.test(ua));
  if (!/iPhone|iPod/.test(ua) && !ios) return 0;
  const standalone = (navigator as { standalone?: boolean }).standalone || matchMedia('(display-mode: standalone)').matches;
  if (standalone) return 0;
  const portrait = innerHeight > innerWidth;
  // ページが画面の最上端から始まっている（ステータスバーの裏まで伸びている）ときだけ
  const sh = Math.max(screen.width, screen.height);
  if (!portrait || innerHeight < sh * 0.96 - 2) return 0;
  return sh >= 852 ? 59 : sh >= 812 ? 47 : 20;
}

export function applySafeArea() {
  const root = document.documentElement.style;
  const o = override();
  if (o) {
    root.setProperty('--safe-t', `${o[0]}px`);
    root.setProperty('--safe-b', `${o[1]}px`);
    root.setProperty('--safe-l', `${o[2]}px`);
    root.setProperty('--safe-r', `${o[3]}px`);
    document.documentElement.dataset.safe = 'debug';
    return;
  }
  delete document.documentElement.dataset.safe;
  for (const k of ['--safe-b', '--safe-l', '--safe-r']) root.removeProperty(k);
  const guess = iosGuessTop();
  if (guess && envTop() < 1) root.setProperty('--safe-t', `max(env(safe-area-inset-top, 0px), ${guess}px)`);
  else root.removeProperty('--safe-t');
}

export function initSafeArea() {
  applySafeArea();
  let t = 0;
  const again = () => {
    clearTimeout(t);
    t = window.setTimeout(applySafeArea, 120);
  };
  addEventListener('resize', again);
  addEventListener('orientationchange', again);
  addEventListener('hashchange', () => readParam() != null && applySafeArea());
}
